<template>
  <div class="Pollster">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-expansion-panel
              v-model="panel"
              expand
              popout
            >
              <v-expansion-panel-content>
                <template v-slot:header>
                  <v-card-title class="title">
                    Aplicar Filtros
                  </v-card-title>
                </template>

                <v-card>
                  <v-card-text>
                    <v-layout wrap justify-space-between>
                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuIni"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Inicial"
                            v-model="dateIni"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser anterior a la fecha final"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateIni"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>

                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuEnd"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Final"
                            v-model="dateEnd"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser posterior a la fecha inicial"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateEnd"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>
                    </v-layout>

                    <v-layout row wrap v-if="filterBy">
                      <v-flex xs12 v-for="(filt, index) in filterBy" :key="filt.id">
                        <v-autocomplete
                          :items="filt.choices"
                          :label="'Filtrar por ' + filt.label"
                          v-model="filter[index]"
                          :disabled="loadingPollster || loadingTable"
                          color="secondary"
                          item-text="label"
                          item-value="id"
                          hide-no-data
                          hint="Vacio para no filtrar"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-card-actions>
              <v-spacer/>
              <v-btn color="warning"
                :disabled="loadingPollster || loadingTable"
                @click="clear()"
              >
                Limpiar
              </v-btn>

              <v-btn
                color="info"
                :disabled="loadingPollster || loadingTable || vDate"
                @click="loadData()"
              >
                <v-icon left>cloud_download</v-icon> {{ btnText }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title class="title">
              Reporte de Encuestas Efectivas por Encuestador
              <v-spacer/>

              <v-card-actions>
                <v-btn color="info" :v-If="dataVals === null">
                  <download-csv
                    :data="dataVals"
                    :name="'Reporte de Encuestas Efectivas por Encuestador.csv'"
                    :labels="labels"
                    :fields="fields"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loadingTable"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <strong>
                (*) La fecha indicada hace referencia a la fecha en que
                el formulario se marcó como finalizado.
                <br>
                (**) Las columnas de fecha, hacen referencia a encuestas
                alojadas en el servidor sean efectivas o no.
              </strong>

              <data-status
                :headers="headers"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <!-- FIXME: no grafica cuando es un solo punto, libreria -->
          <v-card>
            <v-card-title class="title">
              Resumen de Actividades por Encuestador
            </v-card-title>

            <v-card-text
              v-if="loadingPollster"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else-if="chartSeries.length > 1">
              <strong>(*) La fecha indicada hace referencia a la fecha en que
                el formulario se marcó como finalizado.
              </strong>

              <chart-line
                :chartOptions="chartOptions"
                :chartSeries="chartSeries"
                :key="chartKey"
              />
            </v-card-text>
            <!-- <v-card-text>
              {{ chartSeries }}
            </v-card-text> -->
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import chartLine from '@/components/Charts/LineBase'
import dataBaseStatus from '@/components/Tables/TableBaseStatus'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'Pollster',

  components: {
    'chart-line': chartLine,
    'data-status': dataBaseStatus,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.loadFiltro()
    this.loadData()
  },

  data: function () {
    return {
      backConf: {
        path: '/charts/resumen_enc',
        page: 1
      },

      loadingPollster: false,
      loadingTable: false,
      progressSize: 70,
      progressWidth: 7,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      filter: [],

      filterBy: null,

      chartSeries: [],
      chartOptions: {
        chart: {
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        colors: [
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800',
          '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8',
          '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD',
          '#7A918D', '#BAFF29'
        ],
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          position: 'right',
          fontSize: '10px',
          width: 200
        },
        stroke: {
          // curve: 'straight'
          width: 2,
          curve: 'smooth'
        },
        responsive: [{
          breakpoint: 721,
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }],

        markers: {
          size: 3,
          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            rotate: -15,
            rotateAlways: true
          },
          title: {
            text: 'Fecha'
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          },
          tooltip: {
            enabled: true
          }
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val
                }
              }
            }
          ]
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      chartKey: 0,

      headers: [
        { text: 'Encuestador', value: 'encuestador', align: 'left' },
        { text: 'Documento', value: 'documento' },
        { text: 'Encuestas Efectivas', value: 'efectivas' },
        { text: 'Encuestas No Efectivas', value: 'no_efectivas' },
        { text: 'Cubrimiento (%)', value: 'meta_enc' },
        { text: 'Fecha Primer Envio', value: 'fechai' },
        { text: 'Fecha Último Envío', value: 'fechaf' },
        { text: 'Estado', value: 'estado' }
      ],
      labels: {
        encuestador: 'Encuestador',
        documento: 'Documento',
        efectivas: 'Encuestas Efectivas',
        no_efectivas: 'Encuestas No Efectivas',
        meta_enc: 'Cubrimiento (%)',
        fechai: 'Fecha Primer Envío',
        fechaf: 'Fecha Último Envío',
        estado: 'Estado'
      },
      fields: ['encuestador', 'documento', 'efectivas', 'no_efectivas', 'meta_enc', 'fechai', 'fechaf', 'estado'],

      dataVals: null,
      tableKey: 0
    }
  },

  watch: {
    '$store.state.actualOperation': function () {
      this.operativo = this.$store.state.actualOperation.id
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     * @return {boolean} validación de las fechas
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Determina el texto que tendra el boton
     * @return {String} Texto poara poner en el boton
     */
    btnText: function btnText () {
      if (!this.dateIni && !this.dateEnd && !this.filter.length > 0) {
        return 'Cargar Todos'
      }
      return 'Cargar con Filtro'
    },

    /**
     * Genera el objeto para realizar la consulta
     * @return {Object} Objeto de la forma id[field]:id[choice]
     */
    filterToApply: function filterToApply () {
      if (this.filter.length < 1) {
        return null
      }

      let obj = {}

      this.filterBy.forEach(function (filt, index) {
        obj[filt.id] = this.filter[index]
      }, this)
      return obj
    }
  },

  methods: {
    /**
     * Carga los datos de los encuestadores en forma de grafico de lineas
     */
    loadPollster () {
      this.loadingPollster = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'line',
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          filtro: this.filterToApply
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.chartSeries = resp.data
          t.loadingPollster = false
          t.chartKey += 1
        })
        .catch(function (err) {
          t.chartSeries = []
          t.loadingPollster = false
          t.chartKey += 1
          console.error(err)
        })
    },

    /**
     * Carga los datos de los encuestadores en forma de tabla
     */
    loadTablePollster () {
      this.loadingTable = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'table',
          fechainicio: this.dateIni,
          fechafin: this.dateEnd,
          filtro: this.filterToApply
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.loadingTable = false
          t.tableKey += 1
        })
        .catch(function (err) {
          t.dataVals = []
          t.loadingTable = false
          t.tableKey += 1
          console.error(err)
        })
    },

    /**
     * Carga los filtros especificos
     */
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },

    /**
     * Ejecuta las funciones requeridas y cambia el estado del panel de filtros
     */
    loadData () {
      this.loadPollster()
      this.loadTablePollster()
      this.panel = [false]
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.dateIni = null
      this.dateEnd = null
      this.filter = []
    }
  }
}
</script>
